module.exports = __webpack_public_path__ + "img/default_news_16_9.5b22179c.jpg";